import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useNavigationType } from 'react-router';

import { DangerAlert, InfoAlert, Table, WaitingAlert } from '@tmapy/style-guide';

import { QUERY_STATE } from '../../constants';
import { useSelector } from '../../hooks';
import { useEpsiOrdersListResource } from '../../openapi/operations/epsiOrdersList';

import { MainContent } from '../../app/components/MainContent';
import { PageTitle } from '../../app/components/PageTitle';
import { LoadNextItemsBar } from '../../app/components/LoadNextItemsBar';
import { EpsiOrderListItem } from './EpsiOrderListItem';
import { epsiOrderMessages as msg } from './epsiOrderMessages';

export const EpsiOrders: React.FC = () => {
  const navigationType = useNavigationType();
  const filters = useSelector((state) => state.filter.epsiOrderList);

  const { queryState, data, fetchMore } = useEpsiOrdersListResource(
    filters,
    navigationType !== 'PUSH',
  );

  const epsiOrderList = data?.results ?? [];
  const epsiOrderCount = data?.count;
  const isFiltered = Object.values(filters).some((filter) => filter);

  function handleNextBtnClick() {
    if (data?.next) {
      fetchMore(data.next);
    }
  }

  return (
    <MainContent width='fit' scrollRestorationPrefix='epsiorderlist'>
      <article className='sg-u-vs-2'>
        <header className='sg-u-vs-2'>
          <PageTitle>
            <FormattedMessage {...msg.listTitle} />
          </PageTitle>
          <p>
            <FormattedMessage {...msg.listDescription} />
          </p>
        </header>

        {queryState === QUERY_STATE.WAITING && epsiOrderList.length < 1 && (
          <WaitingAlert>
            <FormattedMessage {...msg.listStateWaiting} />
          </WaitingAlert>
        )}
        {queryState === QUERY_STATE.FAIL && epsiOrderList.length < 1 && (
          <DangerAlert>
            <FormattedMessage {...msg.listStateFail} />
          </DangerAlert>
        )}
        {queryState === QUERY_STATE.SUCCESS && epsiOrderList.length < 1 && (
          <InfoAlert>
            {isFiltered ? (
              <FormattedMessage {...msg.listStateFilteredEmpty} />
            ) : (
              <FormattedMessage {...msg.listStateEmpty} />
            )}
          </InfoAlert>
        )}

        {epsiOrderList.length > 0 && (
          <div className='sg-u-box sg-a-px-2 sg-a-pb-2 sg-u-vs-2'>
            <div className='sg-a-mx--2'>
              <Table isClickable>
                <thead>
                  <tr>
                    <th className='sg-a-ta-c'>
                      <div>
                        <FormattedMessage {...msg.columnNumber} />
                      </div>
                      <div>
                        <FormattedMessage {...msg.columnState} />
                      </div>
                    </th>
                    <th>
                      <FormattedMessage {...msg.columnIdPodani} />
                    </th>
                    <th>
                      <FormattedMessage {...msg.columnZadatel} />
                    </th>
                    <th>
                      <FormattedMessage {...msg.columnStatusZadatele} />
                    </th>
                    <th>
                      <FormattedMessage {...msg.columnPspiObsah} />
                    </th>
                    <th className='sg-a-ta-r sg-a-ws-nw'>
                      <FormattedMessage {...msg.columnDatumPlatnosti} />
                    </th>
                    <th className='sg-a-ta-r sg-a-ws-nw'>
                      <FormattedMessage {...msg.columnCreated} />
                    </th>
                    <th />
                  </tr>
                </thead>
                <tbody>
                  {epsiOrderList.map((epsiOrderItem) => (
                    <EpsiOrderListItem key={epsiOrderItem.id} data={epsiOrderItem} />
                  ))}
                </tbody>
              </Table>
            </div>
            <LoadNextItemsBar
              count={epsiOrderList.length}
              total={epsiOrderCount!}
              queryState={queryState}
              onNextBtnClick={handleNextBtnClick}
            />
          </div>
        )}
      </article>
    </MainContent>
  );
};
